import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import { installerAttribution } from './lib/attribution';
import './index.css';

// Avant le rendu, et sur chaque page : le gclid n'existe que sur l'URL
// d'arrivée. Voir lib/attribution.ts.
installerAttribution();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);
